import styled from 'styled-components'

import { ClinTheme } from '../../../ClinTheme'
import { mediaQueryDown } from '../../../utils/mediaQuery'

const desktopUpBreakpoint = ClinTheme.breakpoints[2]

interface IStyledFixedWidthContainerProps {
  width?: number
}

export const StyledLoadingContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  flex: '1 1 auto',
  [mediaQueryDown(desktopUpBreakpoint)]: {
    flex: '1 1 50%'
  }
})

export const StyledLoadingSpinner = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginLeft: ClinTheme.space[2]
})

export const StyledFormContainer = styled.div({
  padding: ClinTheme.space[4]
})

export const StyledRow = styled.div({
  display: 'flex',
  gap: '16px',
  flexWrap: 'wrap',
  alignItems: 'baseline'
})

export const StyledColumn = styled.div<IStyledFixedWidthContainerProps>(
  (props) => ({
    flex: '0 0 auto',
    width: props.width ? `${props.width}px` : '100%',

    [mediaQueryDown(desktopUpBreakpoint)]: {
      flex: '1 1 100%',
      width: '100%'
    }
  })
)

export const StyledMobileColumn = styled.div<IStyledFixedWidthContainerProps>(
  (props) => ({
    flex: '0 0 auto',
    width: props.width ? `${props.width}px` : '100%',
    display: 'inline-flex',
    gap: '16px',
    alignItems: 'baseline',

    [mediaQueryDown(desktopUpBreakpoint)]: {
      flex: '1 1 100%',
      width: '100%'
    }
  })
)
